export enum SubmissionType {
  If = 'IF',
  Cu = 'CU',
  Pca = 'PCA',
  Pp = 'PP',
}

export const submissionTypes = Object.values(SubmissionType);
